import { Tooltip, TooltipProps } from 'antd';
import { Outlet } from 'react-router-dom';

const CustomTooltip: React.FC<TooltipProps> = (props) => {
  return (
    <Tooltip mouseLeaveDelay={0} mouseEnterDelay={0.5} overlayStyle={{ pointerEvents: 'none' }} {...props}>
      {props.children}
    </Tooltip>
  );
};

export default CustomTooltip;
